import type { Simplify } from "type-fest";

import type { AssessmentId, FormProgress } from "@thalamos/haven-common";

import api from "../index.js";

/** How far an assessment has got, or that it could not be told. */
export type ProgressReading =
  Simplify<{ kind: "read" } & FormProgress> | { kind: "unavailable" };

/** Never rejects: a request that fails reads as `unavailable`. */
export const readAssessmentProgress = async (
  assessmentId: AssessmentId,
): Promise<ProgressReading> => {
  try {
    const read = await api.formDraft.progress(assessmentId);

    return read.data === undefined
      ? { kind: "unavailable" }
      : { kind: "read", ...read.data };
  } catch {
    return { kind: "unavailable" };
  }
};
